module.exports = __webpack_public_path__ + "static/media/T0.6ae04c3c.svg";